import React from 'react'
import { Card, Details, DetailsContainer, Divisor, Header, TimeInformation, Title } from './styles'
import { IconComponent } from '~/assets/icons/component'

const LastUpdate = ({ children }: { children: string }): JSX.Element => (
  <TimeInformation>
    <IconComponent name="refresh" />
    {children}
  </TimeInformation>
)

const Statistics = ({ children }: { children: string[] }): JSX.Element => (
  <DetailsContainer>
    {children.map((statistic, index) => {
      const hasDivisor = index !== children.length - 1

      return (
        <React.Fragment key={statistic}>
          <Details>{statistic}</Details>
          {hasDivisor && <Divisor />}
        </React.Fragment>
      )
    })}
  </DetailsContainer>
)

interface ActivityProps {
  title: string
  lastUpdate: string
  statistics: string[]
}

export const Activity = ({ title, lastUpdate, statistics }: ActivityProps): JSX.Element => {
  return (
    <Card>
      <Header>
        <Title>{title}</Title>
        <LastUpdate>{lastUpdate}</LastUpdate>
      </Header>

      <Statistics>{statistics}</Statistics>
    </Card>
  )
}
